import mediator from "@tvg/mediator";

export const raceSelectorGtmEvent = ({
  currentRaceNumber,
  raceNumber,
  trackName,
  destinationUrl
}: {
  currentRaceNumber: string | null;
  raceNumber: string;
  trackName?: string;
  destinationUrl: string;
}) => {
  mediator.base.dispatch({
    type: "NAVIGATION:MENU_CLICK",
    payload: {
      action: "Program Race Selected",
      link: `R${raceNumber}`,
      destinationUrl,
      trackName,
      selectionRaceNumber: raceNumber,
      currentRaceNumber,
      module: "race_selector"
    }
  });
};

export const betSelectorGtmEvent = ({
  betType,
  raceNumber,
  trackName
}: {
  betType?: string;
  raceNumber: string | null;
  trackName: string;
}) => {
  mediator.base.dispatch({
    type: "NAVIGATION:BET_SELECTOR_CLICK",
    payload: {
      event: "program",
      gaEventCategory: "Program",
      gaEventAction: "Bet Type Selected",
      betType: `${betType}`,
      module: "Bet Selector",
      tag: undefined,
      raceNumber,
      trackName,
      sport: "Horse Racing"
    }
  });
};

export const runnerSelectionEvent = ({
  runnerName,
  raceNumber,
  trackName
}: {
  runnerName: string;
  raceNumber?: string;
  trackName?: string;
}) => {
  mediator.base.dispatch({
    type: "RUNNER_TAGS_EXPANDED",
    payload: {
      runnerName,
      raceNumber,
      trackName
    }
  });
};

export const handicappingTabEvent = ({
  label,
  raceNumber,
  trackName
}: {
  label: string;
  raceNumber?: string;
  trackName?: string;
}) => {
  mediator.base.dispatch({
    type: "HANDICAPPING_TAB_OPENED",
    payload: {
      label,
      raceNumber,
      trackName
    }
  });
};
